import { OrderDetail, ParseOrderBrokerage } from 'v3/common/types/order';
import { InstrumentType } from 'v3/common/types/type';
import { BrokerageConfig, Charge } from './type';

const chargeTypes: Array<keyof BrokerageConfig> = [
  'brokerage',
  'stt',
  'gst',
  'sebi',
  'nseipft',
  'stampDuty',
  'exchangeTransaction',
];

export const parseOrder = (orderDetail: OrderDetail): ParseOrderBrokerage => {
  const isEntry = orderDetail.is_entry === 'true';
  const segment = formatSegment(orderDetail.trading_symbol);

  return {
    ...orderDetail,
    price: Number(orderDetail.price),
    quantity: Number(orderDetail.quantity),
    entryPrice: isEntry ? Number(orderDetail.price) : 0,
    exitPrice: !isEntry ? Number(orderDetail.price) : 0,
    segment,
  };
};

export const formatSegment = (tradingSymbol: string): InstrumentType => {
  if (tradingSymbol.includes('FUT')) return 'FUTURE';
  if (tradingSymbol.includes('CE') || tradingSymbol.includes('PE')) return 'OPTION';
  return 'EQUITY';
};

export const getLowerPrice = (a: number, b: number): number => {
  return Math.min(a, b);
};

export const roundToTwoDecimal = (value: number): number => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

export const getSegmentCharges = (segments: InstrumentType[], chargeConfig: BrokerageConfig) => {
  return segments.map((segment) => {
    const segmentCharges = chargeTypes.reduce(
      (acc, chargeType) => {
        const segmentConfig = chargeConfig?.[chargeType]?.[segment];
        if (segmentConfig) {
          Object.entries(segmentConfig).forEach(([productType, chargeConfig]) => {
            if (chargeConfig) {
              if ('price' in chargeConfig) {
                acc[chargeType] ||= [];
                acc[chargeType]?.push({ productType, charge: chargeConfig });
              } else {
                Object.entries(chargeConfig).forEach(([transactionType, charge]) => {
                  if (charge) {
                    acc[chargeType] ||= [];
                    acc[chargeType]?.push({ productType, transactionType, charge: charge });
                  }
                });
              }
            }
          });
        } else {
          acc[chargeType] ||= [];
          acc[chargeType]?.push({ productType: 'ALL', charge: { price: 0, isPercentage: false } });
        }
        return acc;
      },
      {} as Record<keyof BrokerageConfig, { productType: string; transactionType?: string; charge: Charge }[]>
    );
    return {
      segment: segment,
      charges: segmentCharges,
    };
  });
};
